import { Fragment } from "react"
import { cn } from "@/lib/utils"

export type LibraryCrumb = {
  key: string
  label: string
  /** Клик — выбор родительского узла; у последней крошки (текущий узел) отсутствует. */
  onClick?: () => void
}

/**
 * Хлебные крошки контентной панели Библиотеки: «Шоты / S1E2 / Сц. 3 / Шот 3.2».
 * Одна строка: при нехватке места предки ужимаются раньше текущей крошки,
 * перенос в столбик раздувал бы шапку на сотню пикселей.
 */
export function LibraryBreadcrumbs({ crumbs }: { crumbs: LibraryCrumb[] }) {
  const last = crumbs.length - 1
  return (
    <div className="flex min-w-0 items-center gap-1.5 text-xs text-ui-text-muted">
      {crumbs.map((crumb, index) => (
        <Fragment key={crumb.key}>
          {index > 0 ? (
            <span aria-hidden className="shrink-0">
              /
            </span>
          ) : null}
          {crumb.onClick ? (
            <button
              type="button"
              onClick={crumb.onClick}
              title={crumb.label}
              className={cn(
                "min-w-0 truncate rounded text-ui-text-secondary transition-colors hover:text-ui-text-primary focus-visible:ring-2 focus-visible:ring-[var(--ui-focus-ring)] focus-visible:outline-none",
                // Текущий узел важнее предков: он отдаёт ширину последним.
                index === last ? "shrink" : "shrink-[2]",
              )}
            >
              {crumb.label}
            </button>
          ) : (
            <span
              title={crumb.label}
              className={cn(
                "min-w-0 truncate font-medium text-ui-text-primary",
                index === last ? "shrink" : "shrink-[2]",
              )}
            >
              {crumb.label}
            </span>
          )}
        </Fragment>
      ))}
    </div>
  )
}
